export default __webpack_public_path__ + "static/media/pause_circle_outline.995bd6d7.svg";